import { DETAIL_TABS, DetailTab } from "../types";

export function DetailTabs({
  detailTab,
  setDetailTab,
}: {
  detailTab: DetailTab;
  setDetailTab: (t: DetailTab) => void;
}) {
  return (
    <div className="flex gap-6 border-b border-t border-[#E8EAEF] bg-white px-5">
      {DETAIL_TABS.map((t) => {
        const active = detailTab === t;
        return (
          <button
            key={t}
            type="button"
            onClick={() => setDetailTab(t)}
            className={`relative bg-transparent border-none py-2 cursor-pointer text-[14px] inline-flex items-center gap-1.5 ${
              active
                ? "text-[#525062] font-medium after:content-[''] after:absolute after:inset-x-0 after:-bottom-px after:h-0.5 after:bg-[#525062] after:rounded-sm"
                : "text-[#828A99] font-medium"
            }`}
          >
            {t}
          </button>
        );
      })}
    </div>
  );
}

export default DetailTabs;
